import { AppDispatch } from 'store/index';
import { mapSlice } from 'store/reducers/map';

export const setSubstrateLayerAction =
  (layer: string) => (dispatch: AppDispatch) => {
    dispatch(mapSlice.actions.setSubstrateLayer(layer));
  };

export const toggleOpenFullscreenAction =
  (open: boolean) => (dispatch: AppDispatch) => {
    dispatch(mapSlice.actions.toggleFullscreen(open));
  };
